import { site } from "@/data/portfolioData";
import { ServerRackIllustration } from "./icons/SkillIcons";

export function Hero() {
  return (
    <section className="hero-grid relative z-[2] grid items-center gap-10 px-6 pb-16 pt-5 md:grid-cols-[1.05fr_0.95fr] md:px-14 md:pb-[60px]">
      <div>
        <p className="mb-3.5 animate-fadeInUp text-lg text-ink">
          Hi, my name is {site.shortName}.
        </p>
        <h1 className="mb-6 animate-fadeInUp whitespace-pre-line font-display text-[clamp(2.75rem,8vw,4.75rem)] leading-[0.98] tracking-[-1px] text-ink [animation-delay:0.1s]">
          {site.tagline}
        </h1>
        <p className="mb-8 max-w-[480px] animate-fadeInUp text-lg leading-relaxed text-muted [animation-delay:0.22s]">
          Senior DevOps Engineer, AI Developer & Software Architect with {site.years} years
          building resilient cloud infrastructure, automating CI/CD pipelines, and shipping
          production AI systems across Africa and globally.
        </p>
        <div className="flex flex-wrap gap-4 animate-fadeInUp [animation-delay:0.34s]">
          <a
            href="#contact"
            className="neo-btn rounded-[14px] bg-yellow px-[30px] py-4 text-[17px] text-ink no-underline hover:text-ink"
          >
            Let&apos;s talk
          </a>
          <a
            href="#work"
            className="neo-btn rounded-[14px] bg-white px-[30px] py-4 font-bold text-[17px] text-ink no-underline hover:text-ink"
          >
            See my work
          </a>
        </div>
      </div>

      <div className="relative flex animate-fadeInUp justify-center [animation-delay:0.3s]">
        <div className="absolute left-0 top-[-10px] hidden h-[74px] w-[74px] animate-floatA items-center justify-center rounded-[14px] border-3 border-ink bg-teal shadow-neo md:flex">
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" aria-hidden>
            <rect x="2" y="4" width="20" height="14" rx="2" stroke="#fff" strokeWidth="2" />
            <path d="M6 8l4 3-4 3" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <line x1="12" y1="14" x2="16" y2="14" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>

        <div className="absolute right-[-10px] top-9 hidden h-[60px] w-[60px] animate-floatB items-center justify-center rounded-full border-3 border-ink bg-yellow shadow-neo-sm md:flex">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden>
            <circle cx="7" cy="17" r="3" stroke="#141414" strokeWidth="2" />
            <circle cx="17" cy="7" r="3" stroke="#141414" strokeWidth="2" />
            <path d="M9.5 15 14.5 9" stroke="#141414" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>

        <div className="flex h-[400px] w-[min(340px,100%)] animate-popIn items-center justify-center rounded-[24px_24px_90px_24px] border-3 border-ink bg-pink shadow-neo-lg [animation-delay:0.15s]">
          <ServerRackIllustration />
        </div>

        <div className="absolute bottom-1.5 left-[-4px] hidden animate-floatA items-center gap-1.5 rounded-full border-3 border-ink bg-green px-4 py-2 shadow-neo-sm [animation-delay:0.5s] md:flex">
          <span className="inline-block h-2.5 w-2.5 animate-pulseDot rounded-full bg-ink" />
          <span className="font-display text-[13px] text-ink">Uptime 99.98%</span>
        </div>
      </div>
    </section>
  );
}
